module.exports = __webpack_public_path__ + "img/infoGreen.ddadb909.png";